import { Skeleton } from '@/components/ui/skeleton'

const MenuCategoriesSkeleton = () => {
  return (
    <div className='space-'>
      <div className='space-y-3 bg-[#FAFAFA] rounded-[12px]'>
        {Array.from({ length: 6 }).map((_, index) => (
          <div
            key={index}
            className='rounded-[12px] p-3 sm:p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4 bg-white/60'
          >
            <div className='flex flex-col gap-y-2 w-full'>
              <div>
                <Skeleton className='h-4 w-4 rounded' />
              </div>
              <div>
                <Skeleton className='h-5 w-32 mb-2' />
                <Skeleton className='h-4 w-24' />
              </div>
              <div className='flex items-center gap-x-2 p-2 sm:p-[8px] rounded-[18px] bg-[#F5F5F5] w-fit'>
                <Skeleton className='h-4 w-12' />
                <Skeleton className='h-5 w-8 rounded-full' />
              </div>
            </div>

            <div className='flex items-center gap-2 self-end sm:self-auto'>
              <Skeleton className='h-8 w-8 rounded-full' />
              <Skeleton className='h-8 w-8 rounded-full' />
            </div>
          </div>
        ))}
      </div>

      <div className='flex justify-center mt-6'>
        <div className='flex items-center gap-2'>
          <Skeleton className='h-8 w-8' />
          <Skeleton className='h-8 w-8' />
          <Skeleton className='h-8 w-8' />
          <Skeleton className='h-8 w-8' />
          <Skeleton className='h-8 w-8' />
        </div>
      </div>
    </div>
  )
}

export default MenuCategoriesSkeleton
